module.exports = __webpack_public_path__ + "static/fonts/342F4F_11_0.1310e7b.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_11_0.woff2
// module id = 109
// module chunks = 4